import { render, staticRenderFns } from "./InputConfig.vue?vue&type=template&id=56ace9e5&scoped=true&"
import script from "./InputConfig.vue?vue&type=script&lang=js&"
export * from "./InputConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ace9e5",
  null
  
)

export default component.exports